import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class AnalyticsSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
